<section class="article-template">
  <div class="article-template__container">
    <a routerLink="/artigos" class="article-template__back-link">
      Voltar para todos os artigos
    </a>

    <article class="article-template__content">
      <ng-content></ng-content>
    </article>

    <section class="article-template__legal-notice" aria-label="Aviso legal">
      <h2>Aviso Legal</h2>
      <p>
        Os conteúdos deste blog têm caráter informativo e visam auxiliar usuários a compreenderem melhor o universo dos leilões de imóveis. A Casato Brasil não oferece consultoria jurídica ou assessoria legal. As informações apresentadas baseiam-se em fontes públicas e experiências práticas, podendo variar conforme o caso. Recomenda-se sempre consultar um advogado especializado antes de tomar decisões relacionadas à compra de imóveis em leilão.
      </p>
    </section>

    <section class="article-template__continue-reading" aria-labelledby="continue-reading-title">
      <h2 id="continue-reading-title">Você também pode se interessar</h2>
      <div class="article-template__related-grid">
        @for (article of relatedArticles; track article.path) {
          <a [href]="article.path" class="article-template__related-card" (click)="navigateToArticle($event, article.path)">
            <h3>{{ article.title }}</h3>
            <p>{{ article.description }}</p>
          </a>
        }
      </div>
    </section>
  </div>
</section>
